import { Box, Grid, Paper, Skeleton, Typography } from "@mui/material";
import { LayoutBaseDeDashboard } from "../../shared/layouts";
import OutlinedCard from "./OutlinedCard";
import { useEffect, useState } from "react";
import GraficoRosca from "./GraficoRosca";
import GraficoColuna from "./GraficoColuna";
import { DashboardService, IDashboard } from "../../shared/services/api/DashboardService";
import { getTemaSistema } from "../../shared/contexts";
import GraficoArea from "../../shared/forms/GraficoArea";
import GraficoLinha from "../../shared/forms/GraficoLinha";
import OutlinedCard1 from "./OutlinedCard1";
import GraficoBarra from "../../shared/forms/GraficoBarra";
import GraficoBarra1 from "../../shared/forms/GraficoBarra1";


export const Paginainicial: React.FC = () => { 
  const teme = getTemaSistema();
  const [tema, setTema] = useState<'dark' | 'light'>('light');
  const [loading, setLoading] = useState(false);
  const [totalcolhedores, setTotalColhedores] = useState('0');
  const [totalipiranga, setTotalIpiranga] = useState('0');
  const [totalplanalto, setTotalPlanalto] = useState('0');
  const [totaldia, setTotalDia] = useState(0);
  const [data, setData] = useState<IDashboard>({
    totais:[],
    ano: [],
    fazenda: [],
    ipiranga: [],
    planalto: [],
    diaria: [],
    media: [],
    colhedor: [],
    totaldia: [],
  });

  useEffect(() => {
    if (teme === 'dark') {
      setTema('dark');
    } else {
      setTema('light');
    }
  }, [teme]); 

  type Extrair = {
    titulo: string;
    valor: number;
  };

  type ExtrairIpiranga = {
    ipiranga: number;
  };

  type ExtrairPlanalto = {
    planalto: number;
  };

  type ExtrairDiaria = {
    titulo: string;
    ipiranga: number;
    planalto: number;
  };

  function extrairNomes(titulo: Extrair[]): string[] {
    return titulo ? titulo.map(titulo => titulo.titulo) : [];
  }

  function extrairNomesDiaria(titulo: ExtrairDiaria[]): string[] {
    return titulo ? titulo.map(titulo => titulo.titulo) : [];
  }

  function extrairValores(titulo: Extrair[]): number[] {
    return titulo ? titulo.map(titulo => titulo.valor) : [];
  }

  function extrairValoresIpiranga(titulo: ExtrairIpiranga[]): number[] {
    return titulo ? titulo.map(titulo => titulo.ipiranga) : [];
  }

  function extrairValoresplanalto(titulo: ExtrairPlanalto[]): number[] {
    return titulo ? titulo.map(titulo => titulo.planalto) : [];
  }

  useEffect(() => {
    setLoading(true);
    DashboardService.Dashboard()
      .then((result) => {
        if (result instanceof Error) {
          alert(result.message);
        } else {
          //console.log(result.totais[2].total);
          setData(result);
          setTotalColhedores(result.totais[0].total);
          setTotalIpiranga(result.totais[1].total);
          setTotalPlanalto('0');
          setTotalDia(result.totaldia[0].valor);
          setLoading(false);
        }
      });
  },[]); 

  const optionsDataAno = {
    title: {
      text: 'Quantidade Sacos Colhidos por Ano',
    },
    colors:['#183959'],
    dataLabels: {
      enabled: false,
    },
    theme: {
      mode: tema,
    },
    xaxis: { 
      categories: extrairNomes(data.ano)
    },
    
  };   

  const optionsMedia = {
    title: {  
      text: 'Media por Dia',  
    },
    colors: ['#509bc7', '#fc9228'],
    dataLabels: {
      enabled: false,
    },
    theme: {
      mode: tema,
    }, 
    xaxis: { 
      categories: extrairNomesDiaria(data.media)
    },
  };

  const seriesDataAno = [
    {
      name: 'Quantidade',
      data: extrairValores(data.ano) ?? [],
    }
  ];

  const optionsDataContasDia = {
    title: {  
      text: 'Colheitas Diárias',
    },
    colors: ['#509bc7', '#fc9228'],
    dataLabels: {
      enabled: false,
    },
    theme: {
      mode: tema,
    }, 
    xaxis: { 
      categories: extrairNomesDiaria(data.diaria)
    },
  };

  const seriesData = extrairValores(data.fazenda);
  const labels = extrairNomes(data.fazenda);

  const seriesDataDiaria = [
    {
      name: 'Ipiranga',
      data: extrairValoresIpiranga(data.diaria) ?? [],
    },
    {
      name: 'Planalto',
      data: extrairValoresplanalto(data.diaria) ?? [],
    }
  ];

  const seriesMedia = [
    {
      name: 'Ipiranga',
      data: extrairValoresIpiranga(data.media) ?? [],
    },
    {
      name: 'Planalto',
      data: extrairValoresplanalto(data.media) ?? [],
    }
  ];

  const optionsDataColhedor = {
    title: {
      text: 'Maiores Colhedores ',
    },
    colors:['#183959'],
    dataLabels: {
      enabled: false,
    },
    theme: {
      mode: tema,
    },
    xaxis: { 
      categories: extrairNomes(data.colhedor) 
    }
  };

  const seriesDataColhedor = [
    {
      name: 'Quantidade',
      data: extrairValores(data.colhedor) ?? [],
    }
  ];

  return (
    <LayoutBaseDeDashboard>
      <Box display="flex" component={Paper} variant="outlined" >
        <Grid container item direction="row" >
              <Grid item xs={12} sm={12} md={6} lg={2} xl={2}>
                <OutlinedCard
                  nome="Total de Colhedores"
                  valor={totalcolhedores}
                  cor="#82D2ED"
                  img='/img/pessoas.png' 
                  loading={loading}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={2} xl={2}>
                <OutlinedCard
                  nome="Colhedores na Triunfo"
                  valor={totalipiranga}
                  cor="#82D2ED"
                  img='/img/pessoas.png' 
                  loading={loading}
                />
              </Grid>
              <Grid item xs={12} sm={2} md={2} lg={2} xl={2}>
                <OutlinedCard
                  nome="Colhedores Outros"
                  valor={totalplanalto}
                  cor="#DEED82"
                  img='/img/pessoas.png' 
                  loading={loading}
                />
              </Grid> 
              
              <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                <Box flexDirection="column" margin={0.5} maxHeight={95} style={{ border: '2px solid #ccc', borderRadius: '8px', display: 'flex' }}>
                  <Typography sx={{ fontSize: 12, textAlign: 'center' }} >
                     {'Maiores Colhedores '}
                  </Typography>
                  {loading ? <Skeleton variant="rectangular" height={85}/> : 
                  <GraficoBarra1
                      series={seriesDataColhedor} 
                      options={optionsDataColhedor}
                  />
                }
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={1} xl={1}>
                <OutlinedCard1
                  nome="Total Dia"
                  valor={totaldia}
                  loading={loading} 
                />
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                <Box marginLeft={1} marginTop={0.5} style={{ border: '1px solid #ccc', }}>
                  {loading ? <Skeleton variant="rectangular" height={215}/> : 
                    <GraficoColuna
                      series={seriesDataAno} 
                      options={optionsDataAno}
                      height={215}
                    />
                  }
                </Box>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={3} xl={3} >
               <Box flexDirection="column" marginLeft={1} alignItems={"center"} marginTop={0.5} style={{ justifyContent: 'center', border: '1px solid #ccc', display: 'flex' }}>
                  <Typography sx={{ fontSize: 12, textAlign: 'center' }} >
                     {'Colheita Por Fazenda no Ano'}
                  </Typography>
                  {loading ? <Skeleton variant="rectangular" height={200}/> : 
                    <GraficoRosca
                      series={seriesData}
                      chart={{
                        type: 'donut',
                      }}
                      width={250}
                      labels={labels}
                      themeMode={tema}
                    />
                  }
                </Box>
              </Grid>   
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                <Box marginLeft={1} marginTop={0.5} style={{ border: '1px solid #ccc' }}>
                  {loading ? <Skeleton variant="rectangular" height={212}/> : 
                    <GraficoColuna
                      series={seriesMedia} 
                      options={optionsMedia}
                      height={215}
                    />
                  }
                </Box>
              </Grid>
              <Grid component={Paper} item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Box marginLeft={1} marginTop={0.5} style={{ border: '1px solid #ccc' }}>
                  {loading ? <Skeleton variant="rectangular" height={215}/> : 
                    <GraficoLinha
                      series={seriesDataDiaria} 
                      options={optionsDataContasDia}
                      height={400}
                    />
                  }
                </Box>
              </Grid> 
              
        </Grid>
     </Box>
    </LayoutBaseDeDashboard>
  );  
};   